<template>
    <b-container fluid class="img-bg">
        <b-row no-gutters>
            <b-col sm class="header-column">
                <AdminBar ref="titlebar" title="Napoli Sotterranea Tour" @languageChanged="updateLang"></AdminBar>
            </b-col>
        </b-row>
        <b-row no-gutters class="mainrow">
            <b-col xl="1" class="d-none d-xl-block">
            </b-col>
            <b-col xl="7" lg="8" md="12" >
                <div class="panel tourbox">
                    <Calendar ref="calendar_view" :locale="active_language" @event-click="selectEvent"></Calendar>
                </div>
            </b-col>
            <b-col xl="3" lg="4" md="12">
                <div class="panel eventcard">
                    <EventCard :tour_prop="selected_tour" @host="startHosting" :lang="active_language"></EventCard>
                </div>
            </b-col>
            <b-col xl="1" class="d-none d-xl-block">
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import EventCard from "./EventCard";
    import AdminBar from "./AdminBar";
    import Calendar from "./Calendar";

    export default {
        name: "HostHome",
        data () {
            return {
                active_language: 'EN',
                selected_tour: null,
                userRole_timer: null,
                unsubscribe_listener: null
            }
        },
        components: {
            AdminBar,
            EventCard,
            Calendar
        },
        methods:{
            updateLang: function (_lang) {
                console.log(_lang);
                this.unsubscribe_listener();
                this.fcEvents.length = 0;
                this.fcEvents.sort();
                this.active_language = _lang;
                this.loadcalendar();
            },
            selectEvent: function(event) {
                this.selected_tour = event;
            },
            startHosting: function() {
                console.log(this.selected_tour, this.selected_tour.id);
                let routeData = this.$router.resolve({name: 'host_tour', params: { channel: this.selected_tour.id, folder: this.selected_tour.tour.Origin} });
                window.open(routeData.href, '_blank');
            },
            checkUserRole() {
                if(this.$refs.titlebar.currentUserRole.id !== undefined) {
                    this.loadcalendar();
                    this.active_language = this.$refs.titlebar.currentUserRole.lingua;
                }
            },
            loadcalendar(){
                this.unsubscribe_listener = this.$firebase.eventsCollection.where("tour.Language", "==", this.$store.getters.currentUserRole.lingua).onSnapshot(function (querySnapshot) {
                    this.$refs.calendar_view.addEventsFromSnapshot(querySnapshot);
                    clearTimeout(this.userRole_timer);
                }.bind(this));
            }
        },
        created() {
            this.$nextTick(() => {
                this.userRole_timer = setTimeout(this.checkUserRole, 200);
            })
        },
        beforeDestroy() {
            this.unsubscribe_listener();
        }
    }
</script>

<style scoped>

    .header-column{
        margin-top:1.5%;
        margin-bottom:1.5%;
    }

    .img-bg{
        background-image: url("../../public/ns_bg.jpg");
        background-size: cover;
        background-position: center;
        padding:0;
        height:100%;
        overflow:auto;
    }

    .mainrow{
        min-height:85%;
        padding: 0 10px 0 10px;
    }

    .panel{
        background-color:#fff;
        margin:3px;
        padding:5px;
        border-radius:5px;
    }

    .tourbox{
        border: 5px solid transparent;
        outline: 1px solid #000;
        outline-offset: -5px;
    }

    @media screen and (max-width: 992px) {
        .header-column{
            margin-top:0;
            margin-bottom:5px;
        }

        .mainrow{
            height:50%;
            padding:0;
        }
    }
</style>
